import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface NodeToolbarButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  active?: boolean;
  tone?: 'default' | 'primary' | 'success' | 'warning';
}

const toneClasses = {
  default: 'text-slate-500 hover:bg-slate-100 hover:text-slate-700',
  primary: 'text-blue-600 hover:bg-blue-50 hover:text-blue-700',
  success: 'text-emerald-600 hover:bg-emerald-50 hover:text-emerald-700',
  warning: 'text-amber-600 hover:bg-amber-50 hover:text-amber-700',
};

export function NodeToolbarButton({
  children,
  active = false,
  tone = 'default',
  className = '',
  type = 'button',
  ...props
}: NodeToolbarButtonProps) {
  return (
    <button
      type={type}
      className={`flex h-6 items-center justify-center gap-1 rounded-md px-1.5 text-xs font-medium transition disabled:cursor-not-allowed disabled:opacity-50 ${
        active ? 'bg-slate-100 text-slate-700' : toneClasses[tone]
      } ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}

export function NodeToolbarDivider() {
  return <span aria-hidden="true" className="mx-0.5 h-4 w-px bg-slate-200" />;
}
